import type { mediaPicker as mediaPickerEn } from "../en/mediaPicker";

// Okno výběru fotek (MediaPicker): mřížka knihovny, patička výběru, „Vybrat“ v prohlížeči
// a „Nastavit jako hlavní“ na náhledech galerie.
export const mediaPicker: typeof mediaPickerEn = {
  window: {
    titleSingle: "Vybrat fotku",
    titleMultiple: "Vybrat fotky",
  },
  tabs: {
    library: "Knihovna",
  },
  tile: {
    inGallery: "V galerii",
    current: "Vybraná",
    openViewer: "Velký náhled",
    used_one: "použito {{count}}×",
    used_few: "použito {{count}}×",
    used_other: "použito {{count}}×",
  },
  // Štítek fotky na výšku ve výběru otevřeném z hero místa (hlavní fotka, pozadí hero).
  portrait: "na výšku, ořízne se",
  footer: {
    cancel: "Zrušit",
    add_one: "Přidat vybrané ({{count}})",
    add_few: "Přidat vybrané ({{count}})",
    add_other: "Přidat vybrané ({{count}})",
  },
  empty: {
    filtered: "Filtrům neodpovídá žádná fotka.",
    none: "Knihovna je prázdná.",
    clear: "Zrušit filtr",
    upload: "Nahrát",
  },
  primary: {
    setPrimary: "Nastavit jako hlavní",
  },
  viewer: {
    pick: "Vybrat",
    picked: "Vybráno",
    pickInGallery: "Fotka už je v galerii",
  },
};
